module.exports = __webpack_public_path__ + "static/media/interactive.fd91e24d.PNG";